﻿// @ sourceURL=TabView.ProductPage.class.js
import { $element } from "@grindex-common/helpers/elements";
import { addListener } from "@grindex-common/helpers/domManipulation";
import { classes } from "@grindex-common/helpers/cssGlobals";
import { events } from "@grindex-common/helpers/events";
import { TabView } from "@grindex-client/components/Tabs/TabView.class";

import TabListAsync from "@grindex-client/components/Tabs/TabList.class.async";
import TabNames from "./TabNames.class";

class ProductPageTabView extends TabView {
	constructor(routerRoot, routes, $tabView, ignoreRouting) {
		super(routerRoot, routes, $tabView, ignoreRouting);

		this.async = true;
		this.productTabNames = new TabNames();
		this.tabList = new TabListAsync($tabView, this.router.getCurrentSegment());
		this.tabNames = this.productTabNames.productTabs;

		this.loadedTabCount = 0;
		this.tabsTotal = this.productTabNames.productTabs.length;
		this.haveVisibleTab = false;
		this.requestedTab = this.router.getCurrentSegment();
	}

	init() {
		addListener(window, events.TAB_LOADED, this.onTabLoaded.bind(this));

		this.tabList.createTabs(this.tabNames);

		const overviewTab = this.tabList.getTabByName(this.productTabNames.product.overview);

		overviewTab.activationCallback = () => {
			this.showSideBar();
		};

		overviewTab.deactivationCallback = () => {
			this.hideSideBar();
		};

		this.tabList.tryGetTabs();
	}

	setupTabs() {
		this.scrollTabs.initializeScrollableTabs(this.onTabClick.bind(this));
		super.setupTabs();
	}

	onTabLoaded(event) {
		this.loadedTabCount++;

		// If a tab loaded successfully ('detail' will be undefined on failed tabs)
		if (event.detail) {
			const tabName = event.detail;

			if (tabName === this.productTabNames.product.overview) {
				this.ensureSideBar();
			}
			const loadedTab = this.tabList.tabs.filter((tab) => {
				return tab.tabName === tabName;
			})[0];

			this.tabList.addTabToListOfLoaded(loadedTab);

			const isRequestedTab = this.isRequestedTab(tabName);

			if (isRequestedTab) {
				this.tabList.setCurrentTab(loadedTab);

				this.tabList.disableAllExceptCurrent();

				loadedTab.activate(loadedTab.order);

				this.haveVisibleTab = true;
			} else if (!this.haveVisibleTab) {
				if (loadedTab.order === 1) {
					this.tabList.setCurrentTab(loadedTab);
					this.haveVisibleTab = true;
				}
			}
		}

		if (this.loadedTabCount === this.tabsTotal) {
			this.setupTabs(true);

			window.dispatchEvent(new Event(events.TAB_ALL_LOADED));
		}
	}

	isRequestedTab(eventTab) {
		return eventTab === this.requestedTab;
	}

	switchToTab(tabIndex, skipNavigation) {
		this.tabList.setTabWithFallback(tabIndex * 1);

		this.showTab(skipNavigation);

		// If any card blocks, re-render them with this tab
		// visible so the correct height info can be culled from the DOM
		window.addEventListener("DOMContentLoaded", () => {
			window.dispatchEvent(new CustomEvent(events.TABS_SWITCHED));
		});

		if (this.tabList.currentTabIs(this.productTabNames.technicalSpecifications)) {
			window.dispatchEvent(new CustomEvent(events.TABS_SWITCHED));
		}
	}

	showTab(skipNavigation) {
		if (!skipNavigation && !this.ignoreRouting) {
			this.router.navigate(this.tabList.currentTab.tabName);
		}
	}

	onTabClick(e) {
		const tabIndex = e.currentTarget.dataset.tab;

		this.tabList.setTabWithFallback(tabIndex);

		super.onTabClick(e);
	}

	hideSideBar() {
		if (this.$sideBar) {
			this.$sideBar.parentNode.classList.add(classes.HIDDEN);
			this.$sideBar.classList.add(classes.HIDDEN);
		}
	}

	showSideBar() {
		this.$sideBar.parentNode.classList.remove(classes.HIDDEN);
		this.$sideBar.classList.remove(classes.HIDDEN);
	}

	ensureSideBar() {
		if (!this.$sideBar) {
			this.$sideBar = $element("sidebar");
		}
	}
}

export { ProductPageTabView };
